import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import "../../../assets/css/admin/allAdmins.module.css"
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import moment from "moment";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import api from "../../../api";
import { toast } from "react-toastify";


const Courses = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [admins,setAdmins]=useState([])
  const [classFilter, setClassFilter] = useState(localStorage.getItem('all-courses-class') || '');
  const [statusFilter, setStatusFilter] = useState(localStorage.getItem('all-courses-status') || '');
  const [filteredCourses,setFilteredCourses] = useState([])

  const handleClassChange = (e) =>{
    localStorage.setItem("all-courses-class",e.target.value)
    setClassFilter(e.target.value)
  }

  const handleStatus = (e) => {
    localStorage.setItem("all-courses-status",e.target.value)
    setStatusFilter(e.target.value);
  }


  const getCourses = () => {
    let url = `${baseUrl}/course/by-type?`;

    if (classFilter === "Dynamic") {
      url += `type=Dynamic`;
    } else if (classFilter) {
      url += `className=${classFilter}`;
    }

    axios.get(url)
      .then(res => {
        setAdmins(res.data);
        setFilteredCourses(res.data);
      })
      .catch(e => console.log(e));
  };

  useEffect(()=>{
    getCourses()
  },[classFilter])

    const filterCourses = () => {
      let filtered = [...admins]; // Start with all exams
      if (statusFilter) {
        filtered = filtered.filter((exam) => {
          if (statusFilter === "active") {
            return moment(exam.endDate).isAfter(moment()); // Exam is active if its endDate is after the current date
          } else if (statusFilter === "inactive") {
            return moment(exam.endDate).isBefore(moment()); // Exam is inactive if its endDate is before the current date
          }
          return true; // No filter for status
        });
      }
  
      setFilteredCourses(filtered); // Update filtered exams based on the applied filters
    };

      useEffect(() => {
        filterCourses(); // Apply filters whenever any filter value changes
      }, [statusFilter]);

  const deleteCourse=(a)=>{
    swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          api.post(`${baseUrl}/course/delete/?id=${a.courseID}&filePath=${a.syllabus}&imgFilePath=${a.image}`)
            .then(res=>{
              getCourses()
                swal("Course has been deleted!", {
                    icon: "success",
                  });
                }
            )
            .catch(err=>{
              toast.error(err?.response?.data.message || "Something went wrong")
            })
          
        } 
      });
}

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">
                All Courses
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/course/add' className="text-decoration-none">Add</Link>
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div className={`container ${styles.container}`}>
                  <h4 className="mb-4"> All Courses</h4>
          <div className="filters mb-4 d-flex flex-wrap gap-3">
            <div className="filter-item">
              <label htmlFor="classFilter" className="form-label">Class</label>
              <select
                id="classFilter"
                className="form-select"
                value={classFilter}
                onChange={handleClassChange}
              >
                <option value="" hidden>Select Class</option>
                <option value="Class XI">Class XI</option>
                <option value="Class XII">Class XII</option>
                <option value="Class XII Passed">Class XII Passed</option>
                <option value="Dynamic">Dynamic</option>
              </select>
            </div>

            <div className="filter-item">
              <label htmlFor="statusFilter" className="form-label">Status</label>
              <select
                id="statusFilter"
                className="form-select"
                value={statusFilter}
                onChange={handleStatus}
              >
                <option value="">both</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
          <div style={{overflowX:'scroll'}}>
            <table>
              <thead>
                <tr>
                  <td>ID</td>
                  <td style={{minWidth:'140px'}}>Class</td>
                  <td style={{minWidth:'215px'}}>Title</td>
                  <td>Status</td>
                  <td>Duration</td>
                  <td style={{minWidth:'117px'}}>Start Date</td>
                  <td style={{minWidth:'117px'}}>End Date</td>
                  <td>Price</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {filteredCourses.length > 0 &&
                  filteredCourses.map((a, i) => (
                    <tr key={i}>
                      <td>{a.courseID}</td>
                      <td>{a.className}</td>
                      <td>{a.title}</td>
                      <td>{a.active?'Active':'Inactive'}</td>
                      <td>{a.duration}</td>
                      <td>{moment(a.startDate).format('D MMM YYYY')}</td>
                      <td>{moment(a.endDate).format('D MMM YYYY')}</td>
                      <td>{a.price}</td>
                      <td>
                        <Link to={`/admin/course/edit/${a.courseID}`}><button className="btn btn-success btn-sm m-1 p-1">Edit</button></Link>&nbsp;
                        <button onClick={()=>deleteCourse(a)} className="btn btn-danger btn-sm m-1 p-1">Delete</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Courses;
